module.exports = __webpack_public_path__ + "static/img/next.4595d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/next.png
// module id = eME3
// module chunks = 0